var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.valueData,"z-index":"99999999"}},[_c('spinner-cadu',{attrs:{"line-fg-color":_vm.$vuetify.theme.themes.light.primary1,"size":100,"line-size":5,"speed":0.6,"font-size":30,"spacing":10,"text-fg-color":'white',"message":"Carregando"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }